
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class CompositeConstituentDialog extends SiteEntityDialog<CompositeConstituentRow, any> {
        protected getFormKey() { return CompositeConstituentForm.formKey; }
        protected getIdProperty() { return CompositeConstituentRow.idProperty; }
        protected getLocalTextPrefix() { return CompositeConstituentRow.localTextPrefix; }
        protected getService() { return CompositeConstituentService.baseUrl; }
        protected getDeletePermission() { return CompositeConstituentRow.deletePermission; }
        protected getInsertPermission() { return CompositeConstituentRow.insertPermission; }
        protected getUpdatePermission() { return CompositeConstituentRow.updatePermission; }

        protected form = new CompositeConstituentForm(this.idPrefix);

    }
}